import { formatDateWithLocale } from 'common/dates';
import formatNumber from 'common/js_utils/formatNumber';
import { getForgeIconNameForDisplayType } from 'common/displayTypeMetadata';
import _ from 'lodash';
import { I18n } from 'common/i18n';

export function getDateLabel(updatedAt) {
  return formatDateWithLocale(typeof updatedAt === 'object' ? updatedAt : new Date(updatedAt));
}

export const getViewCountLabel = (viewCount) => {
  const viewLabelTranslation = viewCount === 1 ?
    I18n.t('shared.view_widget.view') : I18n.t('shared.view_widget.views');
  return _.isNumber(viewCount) ? `${formatNumber(viewCount)} ${viewLabelTranslation}` : '';
};

export const getResultCountLabel = (resultCount) => {
  const resultLabelTranslation = resultCount === 1 ?
    I18n.t('shared.result_count_label.one') : I18n.t('shared.result_count_label.other');
  return _.isNumber(resultCount) ? `${formatNumber(resultCount)} ${resultLabelTranslation}` : '';
};

export const getAriaLabel = (view) => `${I18n.t('shared.related_views.view')} ${view.name}`;

// NOTE: This function is used for both related/featured content view cards. Only related views
// will share the updatedAt field, therefore parentRowsupdatedAt will default with the views udpatedAt.
export function getViewCardPropsForView(view, parentRowsUpdatedAt = view.updatedAt) {
  // EN-35805 Cache is not flushed in related views during update to default view.
  // This will sometimes cause the updatedAt value for related content to be stale.
  // Getting the max of the default and the child updated at will get the accurate date.
  const actualUpdatedAt = parentRowsUpdatedAt > view.updatedAt ? parentRowsUpdatedAt : view.updatedAt;
  return {
    ...view,
    contentType: 'internal',
    metadataLeft: formatDateWithLocale(actualUpdatedAt),
    metadataRight: getViewCountLabel(_.get(view, 'viewCount', 0)),
    icon: getForgeIconNameForDisplayType(view.displayType),
    linkProps: {
      'aria-label': getAriaLabel(view)
    }
  };
}

// This is needed because sometimes previewImageId is a GUID and sometimes isn't not.
export function translatePreviewImageIdToImageUrl(previewImageId) {
  let imageUrl = previewImageId;

  if (!_.isEmpty(previewImageId) && !/^(https?:\/\/|data:)/.test(previewImageId)) {
    imageUrl = `/api/views/${window.initialState.view.id}/files/${previewImageId}`;
  }

  return imageUrl;
}

export function getViewCardPropsForExternalContent(externalContent) {
  return {
    contentType: 'external',
    name: externalContent.title,
    description: externalContent.description,
    imageUrl: translatePreviewImageIdToImageUrl(externalContent.previewImageId),
    url: externalContent.url,
    linkProps: {
      'aria-label': getAriaLabel(externalContent)
    }
  };
}

export function getViewCardPropsForFeaturedItem(item) {
  if (item.contentType === 'internal') {
    return getViewCardPropsForView(item.featuredView);
  } else {
    return getViewCardPropsForExternalContent(item);
  }
}

export function getViewCardPropsForCLPExternalContent(externalContent) {
  return {
    contentType: 'external',
    name: externalContent.name,
    description: externalContent.description,
    imageUrl: externalContent.imageUrl,
    url: externalContent.url,
    linkProps: {
      'aria-label': getAriaLabel(externalContent)
    }
  };
}

export function getViewCardPropsForCLPFeaturedItem(item = {}) {
  if (item.contentType === 'external') {
    return getViewCardPropsForCLPExternalContent(item);
  } else {
    return getViewCardPropsForView(item);
  }
}
